export default __webpack_public_path__ + "static/media/empty-leg-management.ade6928b.svg";